"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _selectionDropDownAdvanced = _interopRequireDefault(require("./selection-drop-down-advanced"));

var _datepickerMonSun = _interopRequireDefault(require("./datepicker-mon-sun"));

var _datepickerSunSat = _interopRequireDefault(require("./datepicker-sun-sat"));

var _timePicker = _interopRequireDefault(require("./time-picker"));

var _weekPicker = _interopRequireDefault(require("./week-picker"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var FilterSection =
/*#__PURE__*/
function (_Component) {
  _inherits(FilterSection, _Component);

  function FilterSection(props) {
    var _this;

    _classCallCheck(this, FilterSection);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FilterSection).call(this, props));
    _this.state = {
      open: _this.props.data.defaultStateOpen,
      moreLess: _this.props.data.moreLess,
      inputs: _this.props.data.inputs,
      dropdowns: [],
      timePickers: [],
      weekPickers: [],
      datePickers: []
    };
    return _this;
  }

  _createClass(FilterSection, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data !== this.props.data) {
        this.setState({
          open: nextProps.data.defaultStateOpen,
          moreLess: nextProps.data.moreLess,
          inputs: nextProps.data.inputs,
          dropdowns: [],
          timePickers: [],
          weekPickers: [],
          datePickers: []
        });
      }
    }
  }, {
    key: "getFilterValues",
    value: function getFilterValues() {
      var values = [];
      this.state.inputs.forEach(function (input, index) {
        var inputItem = document.getElementById('input' + input.id);

        if (inputItem) {
          values.push({
            label: input.label,
            value: inputItem.value
          });
        }
      });
      this.state.dropdowns.forEach(function (dropdown, index) {
        if (dropdown) {
          values.push({
            label: dropdown.props.id,
            value: dropdown.getSelection()
          });
        }
      });
      this.state.timePickers.forEach(function (timePicker, index) {
        if (timePicker) {
          values.push({
            label: timePicker.props.title,
            value: timePicker.getTime()
          });
        }
      });
      this.state.weekPickers.forEach(function (weekPicker, index) {
        if (weekPicker) {
          values.push({
            label: weekPicker.props.title,
            value: weekPicker.getWeek()
          });
        }
      });
      this.state.datePickers.forEach(function (datePicker, index) {
        if (datePicker) {
          values.push({
            label: datePicker.props.title,
            value: datePicker.getDate()
          });
        }
      });
      return values;
    }
  }, {
    key: "clearFilters",
    value: function clearFilters() {
      this.state.inputs.forEach(function (input, index) {
        var inputItem = document.getElementById('input' + input.id);

        if (inputItem) {
          inputItem.value = '';
        }
      });
      this.state.dropdowns.forEach(function (dropdown, index) {
        if (dropdown) {
          dropdown.select.setState({
            value: null
          });
        }
      });
      this.state.timePickers.forEach(function (timePicker, index) {
        if (timePicker) {
          timePicker.clear();
        }
      });
      this.state.weekPickers.forEach(function (weekPicker, index) {
        if (weekPicker) {
          weekPicker.clear();
        }
      });
      this.state.datePickers.forEach(function (datePicker, index) {
        if (datePicker) {
          datePicker.clear();
        }
      });
      this.props.clearAction();
    }
  }, {
    key: "toggleFilters",
    value: function toggleFilters() {
      this.setState({
        open: !this.state.open
      });
      this.state.dropdowns = [];
      this.state.timePickers = [];
      this.state.weekPickers = [];
      this.state.datePickers = [];
    }
  }, {
    key: "getFilter",
    value: function getFilter(input) {
      switch (input.type) {
        case 'text':
          return this.getTextInput(input);

        case 'dropdown':
          return this.getDropdown(input);

        case 'advanced-dropdown':
          return this.getAdvancedDropdown(input);

        case 'date-mon-sun':
          return this.getMonSunDate(input);

        case 'date-sun-sat':
          return this.getSunSatDate(input);

        case 'time':
          return this.getTime(input);

        case 'week':
          return this.getWeek(input);
      }
    }
  }, {
    key: "getTextInput",
    value: function getTextInput(input) {
      return _react.default.createElement("div", {
        className: "col-25"
      }, _react.default.createElement("div", null, _react.default.createElement("label", {
        className: "filter-label"
      }, input.label), _react.default.createElement("input", {
        id: 'input' + input.id,
        placeholder: input.placeholder,
        className: "form-control",
        type: "text"
      })));
    }
  }, {
    key: "getDropdown",
    value: function getDropdown(input) {
      return _react.default.createElement("div", {
        className: "col-25"
      }, _react.default.createElement("div", null, _react.default.createElement("label", {
        className: "filter-label"
      }, input.label), _react.default.createElement("select", _defineProperty({
        id: "filter-dropdown",
        className: "form-control"
      }, "id", 'input' + input.id), _react.default.createElement("option", {
        value: '',
        selected: true,
        disabled: true,
        hidden: true
      }, input.placeholder), input.options.map(function (option, index) {
        return _react.default.createElement("option", {
          value: option.value
        }, option.label);
      }))));
    }
  }, {
    key: "getAdvancedDropdown",
    value: function getAdvancedDropdown(input) {
      var _this2 = this;

      return _react.default.createElement("div", {
        className: "col-25"
      }, _react.default.createElement("div", null, _react.default.createElement("label", {
        className: "filter-label"
      }, input.label), _react.default.createElement(_selectionDropDownAdvanced.default, {
        id: input.label,
        options: input.options,
        isSearchable: input.isSearchable,
        isMulti: input.isMulti,
        ref: function ref(dropdown) {
          return _this2.state.dropdowns[_this2.state.dropdowns.length] = dropdown;
        }
      })));
    }
  }, {
    key: "getMonSunDate",
    value: function getMonSunDate(input) {
      var _this3 = this;

      return _react.default.createElement("div", {
        className: "col-25"
      }, _react.default.createElement("div", null, _react.default.createElement(_datepickerMonSun.default, {
        title: input.label,
        noDateOption: input.noDateOption,
        id: "date" + input.id,
        ref: function ref(datePicker) {
          return _this3.state.datePickers[_this3.state.datePickers.length] = datePicker;
        }
      })));
    }
  }, {
    key: "getSunSatDate",
    value: function getSunSatDate(input) {
      var _this4 = this;

      return _react.default.createElement("div", {
        className: "col-25"
      }, _react.default.createElement("div", null, _react.default.createElement(_datepickerSunSat.default, {
        title: input.label,
        noDateOption: input.noDateOption,
        id: "date" + input.id,
        ref: function ref(datePicker) {
          return _this4.state.datePickers[_this4.state.datePickers.length] = datePicker;
        }
      })));
    }
  }, {
    key: "getTime",
    value: function getTime(input) {
      var _this5 = this;

      return _react.default.createElement("div", {
        className: "col-25"
      }, _react.default.createElement("div", null, _react.default.createElement(_timePicker.default, {
        title: input.label,
        ref: function ref(timePicker) {
          return _this5.state.timePickers[_this5.state.timePickers.length] = timePicker;
        }
      })));
    }
  }, {
    key: "getWeek",
    value: function getWeek(input) {
      var _this6 = this;

      return _react.default.createElement("div", {
        className: "col-25"
      }, _react.default.createElement("div", null, _react.default.createElement(_weekPicker.default, {
        title: input.label,
        placeholder: input.placeholder,
        locale: input.locale,
        ref: function ref(weekPicker) {
          return _this6.state.weekPickers[_this6.state.weekPickers.length] = weekPicker;
        }
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      return _react.default.createElement("div", {
        id: "selection-filters",
        className: "selection-filters"
      }, _react.default.createElement("fieldset", null, _react.default.createElement("div", {
        className: "pull-left"
      }, "FILTERS"), // show no filters
      !this.state.open && !this.state.moreLess ? _react.default.createElement("div", {
        className: "pull-right"
      }, _react.default.createElement("button", {
        type: "button",
        className: "button button-transparent pull-right",
        onClick: function onClick() {
          return _this7.toggleFilters();
        }
      }, _react.default.createElement("span", null, "Show filters"), _react.default.createElement("span", {
        className: "fa fa-angle-down"
      }))) : "", _react.default.createElement("br", null), // show all filters
      this.state.open ? _react.default.createElement("div", null, _react.default.createElement("br", null), this.state.inputs.map(function (input, rowIndex) {
        return rowIndex % 4 == 0 ? _react.default.createElement("div", {
          className: "grid-wrapper"
        }, _this7.state.inputs.map(function (input, inputIndex) {
          return inputIndex >= rowIndex && inputIndex <= rowIndex + 3 ? _this7.getFilter(input) : "";
        })) : "";
      })) : "", // show just base filters
      !this.state.open && this.state.moreLess ? _react.default.createElement("div", null, _react.default.createElement("br", null), this.state.inputs.map(function (rowInput, rowIndex) {
        return rowIndex % 4 == 0 && rowInput.isBaseFilter ? _react.default.createElement("div", {
          className: "grid-wrapper"
        }, _this7.state.inputs.map(function (input, inputIndex) {
          return inputIndex >= rowIndex && inputIndex <= rowIndex + 3 && input.isBaseFilter ? _this7.getFilter(input) : "";
        })) : "";
      })) : ""), // show hide filter button
      this.state.open && !this.state.moreLess ? _react.default.createElement("div", {
        className: "apply-selection-filters"
      }, _react.default.createElement("div", {
        className: "pull-left"
      }, _react.default.createElement("span", {
        className: "button-group"
      }, _react.default.createElement("button", {
        type: "button",
        className: "button button-blue",
        onClick: this.props.applyAction
      }, "Apply"), _react.default.createElement("button", {
        type: "button",
        className: "button button-transparent",
        onClick: function onClick() {
          return _this7.clearFilters();
        }
      }, "Clear"))), _react.default.createElement("div", {
        className: "pull-right"
      }, _react.default.createElement("button", {
        type: "button",
        className: "button button-transparent",
        onClick: function onClick() {
          return _this7.toggleFilters();
        }
      }, _react.default.createElement("span", null, "Hide filters"), _react.default.createElement("span", {
        className: "fa fa-angle-up"
      })))) : "", // show more / less buttons
      this.state.moreLess ? _react.default.createElement("div", {
        className: "apply-selection-filters"
      }, _react.default.createElement("div", {
        className: "pull-left"
      }, _react.default.createElement("span", {
        className: "button-group"
      }, _react.default.createElement("button", {
        type: "button",
        className: "button button-blue",
        onClick: this.props.applyAction
      }, "Apply"), _react.default.createElement("button", {
        type: "button",
        className: "button button-transparent",
        onClick: function onClick() {
          return _this7.clearFilters();
        }
      }, "Clear"))), _react.default.createElement("div", {
        className: "pull-right"
      }, // show less button
      this.state.open ? _react.default.createElement("button", {
        type: "button",
        className: "button button-transparent",
        onClick: function onClick() {
          return _this7.toggleFilters();
        }
      }, _react.default.createElement("span", {
        id: "more-less-btn"
      }, "Less filters"), _react.default.createElement("span", {
        id: "angle-btn",
        className: "fa fa-angle-up"
      })) // show more button
      : _react.default.createElement("button", {
        type: "button",
        className: "button button-transparent",
        onClick: function onClick() {
          return _this7.toggleFilters();
        }
      }, _react.default.createElement("span", {
        id: "more-less-btn"
      }, "More filters"), _react.default.createElement("span", {
        id: "angle-btn",
        className: "fa fa-angle-down"
      })))) : "");
    }
  }]);

  return FilterSection;
}(_react.Component);

var _default = FilterSection;
exports.default = _default;